import React, {useEffect, useState} from "react";
import axiApi from "ApiCaller";
import {useNavigate} from "react-router-dom";
import NavBreadcrumb from "../../components/NavBreadcrum";
import {useTranslation} from "react-i18next";
import navs from "./navs";
import moment from "moment";

const ReleasesList = () => {
    const [releases, setReleases] = useState([]);
    const navigate = useNavigate();
    const {t: _tR} = useTranslation("routes");
    const {t: _tT} = useTranslation("tables");

    const title = _tR("labels.releases");
    document.title = title;

    const bread = [
        {
            name: _tR("labels.releases"),
            url: "/releases/",
            current: true,
        },
    ];

    useEffect(() => {
        axiApi
            .get("/api/loggers/releases/")
            .then((resp) => {
                setReleases(resp.data);
            })
            .catch((err) => {
                console.error("Error fetching releases:", err);
            });
    }, []);

    const handleNavigation = (e, version) => {
        e.preventDefault();
        navigate(`/releases/${version}/`);
    };

    return (
        <>
            <NavBreadcrumb navs={navs} bread={bread}></NavBreadcrumb>

            <div className="mt-4">
                <h3 className="mb-4">{_tR("labels.releases-list")}</h3>
                <table className="table ">
                    <tbody>
                        {releases.map((release) => (
                            <tr key={release.release_id}>
                                <td
                                    style={{width: "5%", cursor: "pointer"}}
                                    className="text-center text-primary"
                                    onClick={(e) =>
                                        handleNavigation(e, release.version)
                                    }>
                                    <strong>{release.version}</strong>
                                </td>
                                <td>
                                    {release.title}
                                </td>
                                <td className="text-muted">
                                    {moment(release.created_at).format("MMMM D, YYYY")}
                                </td>
                                <td className="text-end">
                                    <a
                                        href={`/releases/${release.version}/`}
                                        onClick={(e) =>
                                            handleNavigation(e, release.version)
                                        }>
                                        {_tT("labels.notes")}
                                    </a>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </>
    );
};

export default ReleasesList;
